<template>
  <page-component style="position: relative">
    <template #content>

      <v-row class="mt-0">
        <v-col lg="10" md="10" cols="10">
          <span class="font-weight-bold" style="display: inline"
            >تذاكر الطلب</span
          >
        </v-col>
        <v-col lg="2" md="2" cols="2" v-if="CurrentRole == 5">
          <v-btn color="primary" @click="CreateTicket()">
            اضافه مهمه
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col lg="4" md="6" cols="12">
          <v-sheet class="pb-5" style="height: 60vh; overflow: auto">
            <div class="py-5 mr-1 pr-4">
              التذاكر المرسله
              <span
                class="ml-4 font-weight-bold"
                style="float: left; color: #451646"
                >{{ sent_counter }}</span
              >
            </div>
            <v-divider class="mb-5" />
            <v-card
              elevation="0"
              style="border: 1px solid #e9edf4"
              class="pa-2 ma-2"
              v-for="ticket in sent_tickets"
              :key="ticket.id"
            >
              <div>
                {{ ticket.user.name }}
                <span
                  class="py-1 px-4"
                  style="float: left; background-color: #d8dffa"
                  >{{ ticket.status }}</span
                >
              </div>
              <div class="mt-3">{{ ticket.receive.name }}</div>
              <div class="mt-3">
                {{ ticket.created_at.split(".")[0].split("T").join(" | ") }}
                <span class="py-1 px-4" style="float: left"
                  ><v-icon @click="to_ticket_details(ticket.id)" color="primary"
                    >mdi-eye</v-icon
                  ></span
                >
              </div>
            </v-card>
          </v-sheet>
        </v-col>
        <v-col lg="4" md="6" cols="12">
          <v-sheet class="pb-5" style="height: 60vh; overflow: auto">
            <div class="py-5 mr-1 pr-4">
              التذاكر المستلمة
              <span
                class="ml-4 font-weight-bold"
                style="float: left; color: #451646"
                >{{ recieved_counter }}</span
              >
            </div>
            <v-divider class="mb-5" />
            <v-card
              elevation="0"
              style="border: 1px solid #e9edf4"
              class="pa-2 ma-2"
              v-for="ticket in recieved_tickets"
              :key="ticket.id"
            >
              <div>
                {{ ticket.user.name }}
                <span
                  class="py-1 px-4"
                  style="float: left; background-color: #d8dffa"
                  >{{ ticket.status }}</span
                >
              </div>
              <div class="mt-3">{{ ticket.receive.name }}</div>
              <div class="mt-3">
                <v-icon class="mb-1">mdi-calendar</v-icon>
                {{ ticket.created_at.split(".")[0].split("T").join(" | ") }}
                <span class="py-1 px-4" style="float: left"
                  ><v-icon @click="to_ticket_details(ticket.id)" color="primary"
                    >mdi-eye</v-icon
                  ></span
                >
              </div>
            </v-card>
          </v-sheet>
        </v-col>
        <v-col lg="4" md="6" cols="12">
          <v-sheet class="pb-5" style="height: 60vh; overflow: auto">
            <div class="py-5 mr-1 pr-4">
              التذاكر المكتملة
              <span
                class="ml-4 font-weight-bold"
                style="float: left; color: #451646"
                >{{ completed_counter }}</span
              >
            </div>
            <v-divider class="mb-5" />
            <v-card
              elevation="0"
              style="border: 1px solid #e9edf4"
              class="pa-2 ma-2"
              v-for="ticket in completed_tickets"
              :key="ticket.id"
            >
              <div>
                {{ ticket.user.name }}
                <span
                  class="py-1 px-4"
                  style="float: left; background-color: #d8dffa"
                  >{{ ticket.status }}</span
                >
              </div>
              <div class="mt-3">{{ ticket.receive.name }}</div>
              <div class="mt-3">
                {{ ticket.created_at.split(".")[0].split("T").join(" | ") }}
                <span class="py-1 px-4" style="float: left"
                  ><v-icon @click="to_ticket_details(ticket.id)" color="primary"
                    >mdi-eye</v-icon
                  ></span
                >
              </div>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>



      <v-dialog v-model="dialog" width="60%">
        <v-card>
          <v-card-title> محتوي التذكرة </v-card-title>
          <v-card-text>
            <textarea
              v-model="content"
              outlined
              rows="5"
              cols="100%"
              style="width: inherit; border: 1px solid #ddd;padding: 5px;"
            ></textarea>
            
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="dialog = false">الغاء</v-btn>
            <v-btn color="success" @click="saveTaskForRequest">اضافه</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </page-component>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";

export default {
  props: ["agent"],
  data() {
    return {
      agent_data: {},
      recieved_tickets: [],
      completed_tickets: [],
      sent_tickets: [],
      sent_counter: 0,
      recieved_counter: 0,
      completed_counter: 0,

      CurrentRole : null,
      dialog : false,
      content:"",
    };
  },
  mounted(){
    this.CurrentRole = window.localStorage.getItem("role");
    if (
      this.$store.state.quality_request_info.allow_recive === 1 &&  
      [0, 1, 2].includes(this.$store.state.quality_request_info.quality_status) && 
      this.$store.state.quality_request_info.is_followed === 0 
    ) {
      this.setBreadCrumbs([
        "الرئيسية",
        "الطلبات",
        "الطلبات المستلمة",
        this.agent.customer.name,
      ]);
    } else if (
      this.$store.state.quality_request_info.allow_recive === 1 &&  
      [0, 1, 2].includes(this.$store.state.quality_request_info.quality_status) && 
      this.$store.state.quality_request_info.is_followed === 1
    ) {
      this.setBreadCrumbs([
        "الرئيسية",
        "الطلبات",
        "الطلبات المتابعة",
        this.agent.customer.name,
      ]);
    } else if (
      this.$store.state.quality_request_info.allow_recive === 1 &&  
      [5].includes(this.$store.state.quality_request_info.quality_status) 
    ) {
      this.setBreadCrumbs([
        "الرئيسية",
        "الطلبات",
        "الطلبات المؤرشفة",
        this.agent.customer.name,
      ]);
    } else if (
      this.$store.state.quality_request_info.allow_recive === 1 &&  
      [3].includes(this.$store.state.quality_request_info.quality_status) 
    ) {
      this.setBreadCrumbs([
        "الرئيسية",
        "الطلبات",
        "الطلبات المكتملة",
        this.agent.customer.name,
      ]);
    } else if (
      this.$store.state.quality_request_info.NeedTurnedStatus  
    ) {
      this.setBreadCrumbs([
        "الرئيسية",
        "الطلبات",
        "الطلبات بحاجه للتحويل",
        this.agent.customer.name,
      ]);
    } else {
      this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
    }
  },
  created() {
    this.agent_data = this.agent;
    this.get_request_tickets();
    this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
  },
  watch: {
    agent_data: {
      handler(val) {
        val.customer.birth_date = this.date.birth_date;
        val.customer.birth_date_higri = this.date.birth_date_higri;
        val.source = parseInt(val.source);
        val.customer.work = parseInt(val.customer.work);
        this.setBreadCrumbs(["الرئيسية", "الطلبات", val.customer.name]);
      },
    },
  },
  methods: {
    get_request_tickets() {
      Axios.get(`${this.$store.state.url}/agent/ReceivedTasks?req_id=${this.$route.params.id}`, {
        headers: this.request_headers(),
      })
        .then((response) => {
          this.recieved_tickets = response.data.payload.filter(
            (el) => el.req_id == this.$route.params.id
          );
          this.recieved_counter = this.recieved_tickets.length;
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
      Axios.get(`${this.$store.state.url}/agent/SentTasks?req_id=${this.$route.params.id}`, {
        headers: this.request_headers(),
      })
        .then((response) => {
          this.sent_tickets = response.data.payload.filter(
            (el) => el.req_id == this.$route.params.id
          );
          this.sent_counter = this.sent_tickets.length;
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
      Axios.get(`${this.$store.state.url}/agent/CompletedTasks?req_id=${this.$route.params.id}`, {
        headers: this.request_headers(),
      })
        .then((response) => {
          this.completed_tickets = response.data.payload.filter(
            (el) => el.req_id == this.$route.params.id
          );
          this.completed_counter = this.completed_tickets.length;
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },
    to_ticket_details(id) {
      this.$router.push({ name: "quality_tickets_details", params: { ticeket: id } });
    },

    saveTaskForRequest() {
      let body = new FormData();
      body.append("id", this.$route.params.id);
      body.append("task_content", this.content);
      axiosInstance
        .post("employee/quality/request-tasks/add", body)
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.get_request_tickets();
          this.dialog = false;
          this.content = "";
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
          this.dialog = false;
          this.content = "";
        });
    },

    CreateTicket(){
      this.content = this.agent.quacomment;
      this.dialog = true;
    }

  },
};
</script>
<style scoped>
.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #ced4da !important;
}
</style>
